import { render, staticRenderFns } from "./challenge-item.vue?vue&type=template&id=d8daae70&"
import script from "./challenge-item.vue?vue&type=script&lang=js&"
export * from "./challenge-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports